import React, { FC, useCallback, useState, useEffect } from "react";
import { IComment, IFailureMode } from "../types/types";
import {
    Button, Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton, TextField,
    Typography
} from "@material-ui/core";

import { Delete, Edit } from "@material-ui/icons";
import DialogContentText from "@material-ui/core/DialogContentText";
import { useTask } from '../stateManagement/context';

interface ICommentProps {
    comment: IComment
    updateComment: (comment: IComment) => void;
}



const Comment: FC<ICommentProps> = ({ comment, updateComment }) => {

    const [openAddDialog, setOpenAddDialog] = useState<boolean>(false);
    const [areYouSure, setAreYouSure] = useState<boolean>(false);
    const [write_access, setWriteAccess] = useState<boolean>(false);

    const [currentComment, setCurrentComment] = useState<IComment>();

    let tasks = useTask()

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks])

    const handleEdit = () => {
        setCurrentComment(comment)
        setOpenAddDialog(true)
    }

    const addDialogCallback = useCallback(() => {
        setOpenAddDialog(false)

    }, [setOpenAddDialog]);

    const handleAreaYouSure = () => {
        setAreYouSure(false)
    }

    const handleAddComment = () => {
        if (!currentComment) {
            throw new Error("Current comment needs to be set")
        }
        updateComment(currentComment)
        setOpenAddDialog(false)
    }

    const handleClose = () => {
        setOpenAddDialog(false)
    }

    const handleDelete = () => {

        let c = { ...comment }
        c.is_active = false
        updateComment(c)
        setAreYouSure(false)
    }

    const editComment = () => {

        return (<Dialog open={openAddDialog} onClose={handleClose} aria-labelledby="form-dialog-title" fullWidth>
            <DialogTitle id="form-dialog-title">Edit Comment</DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    label="Comment"
                    value={currentComment?.comment}
                    onChange={(event) => {
                        let v = (event.target.value as string);

                        let c = { ...currentComment } as IComment
                        c.comment = v


                        setCurrentComment(c)
                    }} />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleAddComment} color="primary">
                    Submit
                </Button>
            </DialogActions>
        </Dialog>)
    }


    const renderAreYouSure = () => {
        return (
            <Dialog open={areYouSure} onClose={handleAreaYouSure} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Remove comment </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Are you sure you want to remove the comment: <b>{comment.comment}</b>
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAreaYouSure} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }


    return (

        <>{renderAreYouSure()}
            {editComment()}
            <div>
                {comment.comment} <br />
                <div style={{ fontSize: 8 }}>created {comment.created_at} by {comment.user?.email}</div>
                {write_access && <><IconButton color="primary" aria-label="upload picture" component="span" style={{
                    color: "rgb(239,88,43)",

                }} onClick={() => handleEdit()}>
                    <Edit />
                </IconButton>

                    <IconButton color="primary" aria-label="upload picture" component="span" style={{
                        color: "rgb(239,88,43)",

                    }} onClick={() => setAreYouSure(true)} >
                        <Delete />
                    </IconButton>
                </>
                }
            </div>


        </>
    );
}

export default Comment;
